import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import api from '@/api';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import { WBSButton } from '@/common/WBSButton';
import FollowUpRequestsTable from '@/tables/FollowUpRequestsTable';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/follow-ups/follow-up-requests/',
)({
  component: FollowUpRequestsScreen,
});

function FollowUpRequestsScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { groupName } = Route.useParams();
  const { me } = useCurrentUser();
  const { data: groupData } = api.getGroupBySlug.useQuery({
    path: { group_slug: groupName },
  });

  // The exact profile type, not `useCurrentUser().isStudyHelper`, which
  // includes admins. Unlike legacy, platform admins don't see the button:
  // creating a request needs a study helper row, which admins don't have, so
  // the POST would 403.
  const isStudyHelper = me?.profile_type === 'STUDY_HELPER';

  const handleCreateRequest = () => {
    navigate({
      to: '/groups/$groupName/follow-ups/follow-up-requests/new/',
      params: { groupName },
      search: { user_id: undefined },
    });
  };

  return (
    <>
      <GroupHeaderWrapper>
        {/* This group tab's help placement, not the member tab's. */}
        <TitleWithQuestion
          title={t('wbs.follow-up-requests')}
          placement="follow_ups"
        />
        {isStudyHelper && (
          <WBSButton wide onClick={handleCreateRequest}>
            {t('actions.create-a-new-request')}
          </WBSButton>
        )}
      </GroupHeaderWrapper>
      <FollowUpRequestsTable
        groupId={groupData?.id ?? 0}
        groupName={groupData?.name ?? ''}
        groupSlug={groupName}
      />
    </>
  );
}
